import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Mail, Phone } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Tagline */}
          <div className="lg:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_sap-transformation/artifacts/3ianobff_image.png"
              alt="Walaby Consulting"
              className="h-16 w-auto mb-4"
            />
            <p className="text-slate-400 text-sm font-body mt-4">
              {t.footer.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-sm tracking-wide mb-6 text-[#E5A81D]">
              {t.footer.links}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/expertise" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t.nav.expertise}
                </Link>
              </li>
              <li>
                <Link to="/who-we-are" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t.nav.whoWeAre}
                </Link>
              </li>
              <li>
                <Link to="/references" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t.nav.references}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t.nav.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-sm tracking-wide mb-6 text-[#E5A81D]">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#E5A81D] mt-0.5 flex-shrink-0" />
                <span className="text-slate-400 text-sm">{t.contact.info.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#E5A81D] flex-shrink-0" />
                <a href="mailto:contact@walaby.fr" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t.contact.info.email}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#E5A81D] flex-shrink-0" />
                <div className="text-slate-400 text-sm">
                  <div>{t.contact.info.phone}</div>
                  <div>{t.contact.info.mobile}</div>
                </div>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold text-sm tracking-wide mb-6 text-[#E5A81D]">
              {t.footer.legal}
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#privacy" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t.footer.privacy}
                </a>
              </li>
              <li>
                <a href="#terms" className="text-slate-400 hover:text-white text-sm transition-colors">
                  {t.footer.terms}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <p className="text-slate-500 text-sm text-center">
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
